import axios from 'axios';
import user from './user';
import FileSaver from "file-saver";
import {handleError} from "../../common"
//import {_} from "lodash";

const state = {
    loadMoreRequests: true,
    loadMorePastRequests: true,
    requests: [],
    pastRequests: [],
};

const mutations = {
    denyRequest(state, id){
        state.requests = state.requests.filter(obj => {
            return obj.id !== id
        });
    },
    reset(state) {
        state.requests = [];
        state.loadMoreRequests = true;
    },
    resetPast(state) {
        state.pastRequests = [];
        state.loadMorePastsRequests = true;
    },
    setLoad(state, load) {
        state.loadMoreRequests = load;
    },
    setRequests (state, requests) {
       state.requests = requests
    },

    appendRequests (state, requests) {
        if (requests.length){
            state.requests =  state.requests.concat(requests);
        }

    },

    setPastRequests (state, requests) {
        state.pastRequests = requests;
    },

    appendPastRequests (state, requests) {
        if (requests.length){
            state.pastRequests = state.pastRequests.concat(requests);
        }

    },

    setPastLoad(state, load) {
        state.loadMorePastRequests = load;
    },

};

const getters = {

};

const actions = {

    loadRequests({commit}, params = {active: 1}) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/requests', config)
                .then((response) => {
                    if (response.data.success) {
                        if (response.data.active){
                            params.page ? commit('appendRequests', response.data.requests, true) : commit('setRequests', response.data.requests, true);
                            if (response.data.currentPage + 1 >= response.data.pages ) {
                                commit('setLoad', false);
                            }
                        } else {
                            params.page ? commit('appendPastRequests', response.data.requests, true) : commit('setPastRequests', response.data.requests, true);
                            if (response.data.currentPage + 1 >= response.data.pages ) {
                                commit('setPastLoad', false);
                            }
                        }

                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                    commit('setFirstLoading', false, { root: true });
                    commit('setLoading', false, { root: true });
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    denyRequest({commit, dispatch}, id) {
        let config = {
            headers: { 'Authorization': `Bearer ${user.state.token}` },
        };
        return new Promise((resolve, reject) => {
            axios.post('/api/requests/deny', {id: id}, config)
                .then((response) => {
                    if (response.data.success) {
                        commit('pushNotification', {
                            message: "Request status changed",
                            type: "success",
                        } , { root: true });
                        //commit('denyRequest', id);
                        dispatch('loadRequests', {active: 1})
                        dispatch('loadRequests', {active: 0})
                        resolve();
                    } else {
                        commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    },

    exportRequests({commit}, date) {
        let config = {
            responseType: 'arraybuffer' ,
            headers: { 'Authorization': `Bearer ${user.state.token}` },
            params: date
        };
        return new Promise((resolve, reject) => {
            axios.get('/api/requests/export', config)
                .then((response) => {
                    if (response.data) {
                        let str = response.headers["content-disposition"];
                        let regexp = /filename="(.*?)"/g;
                        let matchAll = str.matchAll(regexp);
                        matchAll = Array.from(matchAll)[0];
                        let filename = matchAll[1] !== undefined ? matchAll[1] : 'file.xlsx';
                        let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                        FileSaver.saveAs(blob, filename);
                        resolve();
                    } else {
                        /*commit('pushNotification', {
                            message: "Error",
                            type: "error",
                        } , { root: true });*/
                        reject(response.data.message);
                    }
                })
                .catch((response) => {
                    handleError(response, commit);
                });

        });
    }

};

export default {
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}
